import { AnyAction } from "redux";
import { FindById, Update } from "../../../../controllers/projects"
import { Dispatch } from "react";
import { Result } from "../../../../interfaces";
import { Adapter } from "../../../../shared/adapter";
import { ProjectsAdapter } from "../../../../adapter/projects-adapter";

export const FETCH_UPDATE_PROJECT_REQUEST = 'FETCH_UPDATE_PROJECT_REQUEST';
export const FETCH_UPDATE_PROJECT_SUCCESS = 'FETCH_UPDATE_PROJECT_SUCCESS';
export const FETCH_UPDATE_PROJECT_FAILURE = 'FETCH_UPDATE_PROJECT_FAILURE';
export const SET_UPDATE_PROJECT = 'SET_UPDATE_PROJECT';

interface ActionPagination<T> {
    type: string,
    payload: T
}

const fetchUpdateProjectRequest = () => {
    return {
        type: FETCH_UPDATE_PROJECT_REQUEST,
    };
};

const fetchUpdateProjectSuccess = (data: any): ActionPagination<Result<any>> => {
    return {
        type: FETCH_UPDATE_PROJECT_SUCCESS,
        payload: data
    };
};

const fetchUpdateProjectFailure = (error: any) => {
    return {
        type: FETCH_UPDATE_PROJECT_FAILURE,
        payload: error,
    };
};

export const setUpdateProject = (data: any) => {
    return {
        type: SET_UPDATE_PROJECT,
        payload: data,
    };
};

export const update = (id: string, data: any) => {
    return async (dispatch: Dispatch<AnyAction>) => {
        dispatch(fetchUpdateProjectRequest());
        try {
            const response = await Update(id, data);
            dispatch(fetchUpdateProjectSuccess(
                Adapter.from(response.data).to((value) => new ProjectsAdapter(value).adapt())
            ));
        } catch (error: any) {
            dispatch(fetchUpdateProjectFailure(error.message));
        }
    };
};

export const findById = (id: string) => {
    return async (dispatch: Dispatch<AnyAction>) => {
        dispatch(fetchUpdateProjectRequest());
        try {
            const response = await FindById(id, "fields=*.*");
            dispatch(setUpdateProject(
               response.data
            ));
        } catch (error: any) {
            dispatch(fetchUpdateProjectFailure(error.message));
        }
    };
};
